












import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
    }
})

export default class DadosCpf extends Vue {

    public cpfMask = "###.###.###-##";

    get cpf () {
        return this.$store.state.cotacao.cpf;
    }

    set cpf ( value ) {
        this.$store.commit("SET_CPF", value);
    }

    get errorCpf () {
        return this.$store.state.errors.cpf;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
